import { VariantProps, cva } from 'class-variance-authority'

import { cn } from '@/lib/ui/style-helpers'

import { Badge } from '@/components/lemmala-design-system/badge/badge'
import { TextWithIcon } from '@/components/lemmala-design-system/text-with-icon/text-with-icon'

const subprocessorBadgeVariants = cva(
  'whitespace-nowrap bg-main-background-neutral p-1 text-label-small text-main-foreground-secondary',
  {
    variants: {
      size: {
        default: 'h-5 text-xs',
        lg: 'h-6',
      },
    },
    defaultVariants: {
      size: 'default',
    },
  },
)

export type SubprocessorBadgeProps = VariantProps<typeof subprocessorBadgeVariants>

export const SubprocessorBadge = ({ size }: SubprocessorBadgeProps) => {
  return (
    <Badge
      variant='outline'
      data-testid='subprocessor-badge'
      className={cn(subprocessorBadgeVariants({ size }), 'flex justify-between')}
    >
      <TextWithIcon text='Sub-processor' iconPosition='start' />
    </Badge>
  )
}
